import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType, StepOfType } from 'commonTypes/api/scenarios/scenario';

import { useAppSelector } from 'shared/lib';

import { getScenario, getScenarioContent } from 'entities/scenario';

export const useCurrentScenario = <T extends SCENARIO_STEP>() => {
  const step = useAppSelector(getScenario);
  return step as StepOfType<T>;
};

export const useCurrentScenarioStep = <T extends SCENARIO_STEP>() => {
  const step = useAppSelector(getScenario);
  return step?.step as StepOfType<T>['step'];
};

export const useCurrentScenarioCalcId = () => {
  const step = useAppSelector(getScenario);
  return step?.analytics?.calcId;
};

export const useCurrentScenarioCategories = () => {
  const step = useAppSelector(getScenario);
  const { category = 0, subCategory = 0 } = step?.analytics?.flow || {};
  return { category, subCategory };
};

export const useCurrentContentScenario = <T extends SCENARIO_STEP>() => {
  const step = useAppSelector(getScenarioContent);
  return step as ContentOfType<T>;
};

export const useCurrentScenarioInteraction = <T extends SCENARIO_STEP>() => {
  const step = useAppSelector(getScenario);

  return step?.interactions as StepOfType<T>['interactions'];
};
